export default {"src":"/_next/static/media/hand.71a195d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};